import { useState, useEffect } from 'react';
import { Box, Container, IconButton, Typography, Paper, Button, Alert } from '@mui/material';
import { ArrowLeft, ExternalLink } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const SignUpPage = () => {
  const navigate = useNavigate();
  const [iframeError, setIframeError] = useState(false);
  const externalUrl = "https://ric.recruitmentintelligence.com/sign-up";

  // Handle iframe load errors
  const handleIframeError = () => {
    setIframeError(true);
  };

  // Open in new tab
  const openExternalLink = () => {
    window.open(externalUrl, '_blank', 'noopener,noreferrer');
  };

  // Check if iframe loaded successfully
/*   useEffect(() => {
    const timer = setTimeout(() => {
      // If iframe hasn't loaded properly after 3 seconds, assume there's an issue
      const iframe = document.querySelector('iframe');
      if (iframe && (!iframe.contentWindow || iframe.contentWindow.length === 0)) {
        setIframeError(true);
      }
    }, 3000);

    return () => clearTimeout(timer);
  }, []); */


  return (
    <Box sx={{ py: 4 }}>
      <Container maxWidth="lg">
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
          <IconButton 
            onClick={() => navigate(-1)} 
            sx={{ mr: 2 }}
            aria-label="Go back"
          >
            <ArrowLeft />
          </IconButton>
          <Typography variant="h5" component="h1">Sign Up</Typography>
        </Box>
        
        {iframeError ? (
          <Paper 
            elevation={3} 
            sx={{ 
              borderRadius: 2,
              p: 4,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 3
            }}
          >
            <Alert severity="info" sx={{ width: '100%' }}>
              We cannot display the sign-up form directly in this page due to security restrictions.
            </Alert>
            
            <Typography variant="body1" align="center">
              Please click the button below to open the sign-up form in a new tab.
            </Typography>
            
            <Button 
              variant="contained" 
              color="primary" 
              size="large"
              onClick={openExternalLink}
              endIcon={<ExternalLink size={18} />}
              sx={{ mt: 2 }}
            >
              Open Sign-up Form
            </Button>
          </Paper>
        ) : (
          <Paper 
            elevation={3} 
            sx={{ 
              borderRadius: 2,
              overflow: 'hidden',
              height: 'calc(100vh - 150px)',
              minHeight: '600px',
              position: 'relative'
            }}
          >
            <Box
              component="iframe"
              src={externalUrl}
              sx={{
                width: '100%',
                height: '100%',
                border: 'none',
              }}
              title="Sign Up Form"
              onError={handleIframeError}
            />
            
            {/* Fallback message that appears if iframe doesn't load */}
            <Box 
              sx={{ 
                position: 'absolute', 
                top: '50%', 
                left: '50%', 
                transform: 'translate(-50%, -50%)',
                display: iframeError ? 'block' : 'none',
                textAlign: 'center',
                p: 3,
                bgcolor: 'background.paper',
                borderRadius: 2,
                boxShadow: 3,
                maxWidth: '80%'
              }}
            >
              <Typography variant="h6" gutterBottom>
                Unable to load the sign-up form
              </Typography>
              <Button 
                variant="contained" 
                color="primary"
                onClick={openExternalLink}
                endIcon={<ExternalLink size={18} />}
                sx={{ mt: 2 }}
              >
                Open in New Tab
              </Button>
            </Box>
          </Paper>
        )}
      </Container>
    </Box>
  );
};

export default SignUpPage;
